import jpg from './plane-mobile.jpg'
import jpg2x from './plane-mobile@2x.jpg'
import webp from './plane-mobile.webp'
import webp2x from './plane-mobile@2x.webp'

const index = {
  jpg,
  jpg2x,
  webp,
  webp2x,
}

export default index
